import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Components
import Logo from '../Global/Logo'

// Actions
import {
  showModal,
} from '../../actions/modal'

class Footer extends Component {

  static propTypes = {
    appName: PropTypes.string.isRequired,
    authenticated: PropTypes.bool
  }

  handleInviteFriendsClick = () => {
    this.props.showModal({
      modalType: 'share-this',
      optionalProps: {
        shareUrl: "http://www.lockerlinked.com",
        shareText: 'Hey, check out Locker Linked!'
      }
    })
  }

  render() {
    const { appName, user } = this.props

    return (
      <footer>
        <div className="inner-wrap">
          <div className="nav-container">
            <Logo
              linkPath="/"
              linkTitle="Deb"
            />
            <nav>
              <a
                href="https://www.lockerlinked.com/terms-of-use"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms of Service
              </a>
              <a
                href="https://www.lockerlinked.com/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
              <a
                href="https://www.lockerlinked.com/refund-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Refund Policy
              </a>
              <a
                href="https://www.lockerlinked.com/feedback"
                target="_blank"
                rel="noopener noreferrer"
              >
                Contact Us
              </a>
              <a
                onClick={this.handleInviteFriendsClick}
              >
                Invite Friends
              </a>
              {
                user.isLoggedIn ?
                (
                  <Link to="/log-out">Log Out</Link>
                ) : (
                  null
                )
              }
            </nav>
          </div>
          <div className="social-nav">
            <Link
              to="https://www.facebook.com/lockerlinked/"
              target="_blank"
              title="Locker Linked on Facebook"
            >
              <svg><use xlinkHref="#facebook"/></svg>
            </Link>
            <Link
              to="https://twitter.com/lockerlinked/"
              target="_blank"
              title="Locker Linked on Twitter"
            >
              <svg><use xlinkHref="#twitter"/></svg>
            </Link>
          </div>

        </div>
        <div className="inner-wrap copyright">© {(new Date().getFullYear())} { appName }. All Rights Reserved.</div>
      </footer>
    )
  }
}

const mapStateToProps =  state  => {
  return {
    user: state.user
  }
}

const mapDispatchToProps = dispatch => {
  return {
    showModal: (modalType) => {
      dispatch(showModal(modalType))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Footer)



// WEBPACK FOOTER //
// ./src/components/Global/Footer.js